"use client";

import type { OmniboxDemo } from "@mw/shared/payload-types";

import { useTranslations } from "next-intl";

import { LinkTracked } from "../core/LinkTracked";
import { EventName } from "@mw/shared/analyticsEventNames";

interface OmniboxCTAProps {
  signupWithRedirectLink: string;
  tab: OmniboxDemo["component"];
}

export default function OmniboxCTA({ signupWithRedirectLink, tab }: OmniboxCTAProps) {
  const t = useTranslations("ClientKeys.Globals");

  return (
    <div
      className='mt-16 flex transform-gpu flex-col items-center justify-center gap-12 md:flex-row'
      key={`cta-${tab}`}
    >
      <p className='f-ui-03'>{t("experience_full_audio_platform")}</p>
      <div className='flex gap-8'>
        {tab !== "aiSpeechClassifier" && (
          <LinkTracked
            asButton
            buttonVariants={{ size: "md" }}
            className='min-w-100'
            href={signupWithRedirectLink}
            showExternalLoading
            size='sm'
            target='_blank'
            eventName={EventName.mw_below_omnibox_cta}
            eventProperties={{ tab }}
          >
            {t("sign_up")}
          </LinkTracked>
        )}
      </div>
    </div>
  );
}
